import {
    ApolloProvider,
} from '@apollo/client';
import { client } from '../graphql/client';

export function Apollo({ children }) {
  return (
    <ApolloProvider client={client}>
      {children}
    </ApolloProvider>
  )
}
